import { styled } from '@mui/material';
import omit from 'lodash-es/omit';
import React from 'react';
import { SpinningBase } from './SpinningBase';
import { getStyle } from './style';
const StyledSpinning = styled(SpinningBase)((props) => {
    const { theme, size } = props;
    return getStyle(theme, { size });
});
const RefSpinning = React.forwardRef((props, ref) => (React.createElement(StyledSpinning, { ...props, ref: ref })));
//  The exposed components must support the use of ref.
const Spinning = React.forwardRef((props, ref) => {
    const internalProps = omit(props, ['style']);
    return (React.createElement(RefSpinning, { ...internalProps, ref: ref, size: !props.size ? 'medium' : props.size }));
});
export default Spinning;
